import React from 'react'
import { Header } from 'components/Header'
import { QueryStatus } from 'components/QueryStatus'
import { useDayforceBookingsContextValue } from '../context/DayforceBookingsProvider'

export const DayforceBookingsHeader = () => {
  const { state, actions } = useDayforceBookingsContextValue()

  return (
    <Header
      title="Dayforce Bookings"
      rightContent={
        <QueryStatus
          dataUpdatedAt={state.dataUpdatedAt}
          isFetching={state.isFetching}
          refetch={actions.refetch}
          isError={state.isError}
          error={state.error}
        />
      }
    />
  )
}
